import { getOrdinalSuffix } from '@noths/polaris-client-utils';
import { isTomorrow, isValid, parseISO } from 'date-fns';

export const getFormattedDeliveryDate = (date: string) => {
  const dateObj = parseISO(date);

  if (!isValid(dateObj)) {
    return '';
  }

  if (isTomorrow(dateObj)) {
    return 'Tomorrow';
  }

  const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'short' }).format(dateObj);
  const monthName = new Intl.DateTimeFormat('en-GB', { month: 'short' }).format(dateObj);
  const dayOfMonth = dateObj.getDate();

  return `${dayName} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)} ${monthName}`;
};
